import * as React from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { Card, CardHeader, CardContent, withStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import AccountCircle from '@material-ui/icons/AccountCircle';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import countries from '../signup/CountrySelect';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import EditIcon from '@material-ui/icons/Edit';
import { DesignPref, DesignSofts } from 'src/reducers/userProfile';
import MenuItem from '@material-ui/core/MenuItem';
import { ManufacturerData, TatData } from 'src/reducers/fileUpload';
// import Link from '@material-ui/core/Link';
// import TextareaAutosize from '@material-ui/core/TextareaAutosize';

export interface UserProfileViewProps {
    updateCustomerType: (customerType: string) => void;
    updateCustomerName: (customerName: string) => void;
    updateEmail: (customerEmail: string) => void;
    updateNumber: (customerNumber: string) => void;
    updateAddressOne: (customerAddressOne: string) => void;
    updateAddressTwo: (customerAddressTwo: string) => void;
    updateCountry: (customerCountry: string) => void;
    updateState: (customerState: string) => void;
    updateProduct: (customerProduct: string) => void;
    updateScanner: (customerScanner: string) => void;
    updateContactname: (customerContactName: string) => void;
    updateContactnumber: (customerContactNumber: string) => void;
    updateComment: (customerComment: string) => void;
    updateDsoftware: (customerComment: string) => void;
    updateDestination: (updateDestination: string) => void;
    updateTat: (updateTat: string) => void;

    updateOcclusion: (occlusion: string) => void;
    updateDesignType: (designtype: string) => void;
    updatePonticDesign: (Ponticdesign: string) => void;
    updateContact: (contact: string) => void;
    updateModelType: (modeltype: string) => void;
    updateNotes: (notes: string) => void;

    onSubmit: () => void;
    onSubmitDesign: () => void;
    onReset: () => void;
    // updateOcclusion: (occlusion: string) => void;

    customertype: string;
    customername: string;
    customeremail: string;
    customernumber: string;
    customeraddressone: string;
    customeraddresstwo: string;
    customercountry: string;
    customerstate: string;
    customerproduct: string;
    customerscanner: string;
    customercontactName: string;
    customercontactNumber: string;
    customercomment: string;
    custdsoft: string;
    custdest: string;
    custtat: string;

    occlusion: string;
    designType: string;
    ponticDesign: string;
    contact: string;
    modelType: string;
    notes: string;

    custname: string;
    emailid: string;
    phoneno: string;
    address1: string;
    address2: string;
    country: string;
    state: string;
    products: string;
    scanners: string;
    contactname: string;
    contactno: string;
    comments: string;
    dsoft: string;
    destination: string;
    tat: string;

    occulsionArr: DesignPref[];
    designtypeArr: DesignPref[];
    contactArr: DesignPref[];
    ponticdesignArr: DesignPref[];
    modeltypeArr: DesignPref[];

    designSoftwares: DesignSofts[];
    orderDataManufacturer: ManufacturerData[];
    orderDataTat: TatData[];
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120
        },
        selectEmpty: {
            marginTop: theme.spacing(2)
        },
        card: {
            maxWidth: 550
        },
        cardone: {
            maxWidth: 900
        },
        cardHeader: {
            alignItems: 'center'
        },
        paper: {
            marginTop: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main
        },
        form: {
            width: '100%', // Fix IE 11 issue.
        },
        cardHead: {
            textAlign: 'center',
            maxHeight: theme.spacing(1),
            margin: theme.spacing(1)
        },
        textarea: {
            height: 10
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        submit: {
            margin: theme.spacing(1, 0, 0)
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            outlineStyle: 'none',
            boxShadow: 'none',
            borderColor: 'transparent',
            '& :focus': {
                outline: 'none'
            }
        },
        centerButton: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        textHead: {
            fontSize: '1rem',
            fontWeight: 'bolder'
        }
    })
);

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
        },
    },
})(TextField);

// const CardHeaderStyle = withStyles({
//     action: {
//         margin: '-16px'
//     },
// })(CardHeader);

const CardContentStyle = withStyles({
    root: {
        '&:last-child': {
            paddingBottom: '8px'
        },
        padding: '0 16px'
    },
})(CardContent);

const UserProfileView: React.StatelessComponent<UserProfileViewProps> = props => {
    const classes = useStyles({});
    // const inputLabel = React.useRef<HTMLLabelElement>(null);
    const inputCon = React.useRef<HTMLLabelElement>(null);
    const inputDs = React.useRef<HTMLLabelElement>(null);
    const inputDes = React.useRef<HTMLLabelElement>(null);
    const inputTat = React.useRef<HTMLLabelElement>(null);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        props.onReset();
        setOpen(false);
    };
    const handleSubmit = () => {
        props.onSubmit();
        setOpen(false);
    };
    const [opendp, setOpendp] = React.useState(false);
    // const handleOpendp = () => {
    //     setOpendp(true);
    // };
    const handleClosedp = () => {
        props.onReset();
        setOpendp(false);
    };
    const handleSubmitdp = () => {
        props.onSubmitDesign();
        setOpendp(false);
    };

    // const inputOcc = React.useRef<HTMLLabelElement>(null);
    // const [occ, setOcc] = React.useState(0);
    // React.useEffect(() => {
    //     setOcc(inputOcc.current!.offsetWidth);
    // });
    // const inputDtype = React.useRef<HTMLLabelElement>(null);
    // const [dtype, setDtype] = React.useState(0);
    // React.useEffect(() => {
    //     setDtype(inputDtype.current!.offsetWidth);
    // });
    // const inputPDesign = React.useRef<HTMLLabelElement>(null);
    // const [pdesign, setPdesign] = React.useState(0);
    // React.useEffect(() => {
    //     setPdesign(inputPDesign.current!.offsetWidth);
    // });
    // const inputCont = React.useRef<HTMLLabelElement>(null);
    // const [cont, setCont] = React.useState(0);
    // React.useEffect(() => {
    //     setCont(inputCont.current!.offsetWidth);
    // });
    // const inputMtype = React.useRef<HTMLLabelElement>(null);
    // const [mtype, setMtype] = React.useState(0);
    // React.useEffect(() => {
    //     setMtype(inputMtype.current!.offsetWidth);
    // });

    return (
        <div className={classes.root}>
            <div className={classes.paper}>
                <Container component="main" maxWidth="sm">
                    <CssBaseline />
                    <Card className={classes.cardone} variant="outlined">
                        <CardHeader
                            className={classes.cardHead}
                            avatar={
                                <Avatar aria-label="lab" className={classes.avatar}>
                                    <AccountCircle />
                                </Avatar>}
                            title={
                                <h2>Lab Profile</h2>}
                            action={
                                <div>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleOpen}
                                        startIcon={<EditIcon />}
                                    >
                                        Edit
                                    </Button>
                                </div>}
                        />
                        <CardContentStyle>
                            <form className={classes.form} noValidate>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <CssTextField
                                            size="small"
                                            fullWidth
                                            label="Lab Name"
                                            disabled
                                            value={props.customername}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <CssTextField
                                            size="small"
                                            fullWidth
                                            label="Email Address"
                                            disabled
                                            value={props.customeremail}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <CssTextField
                                            fullWidth
                                            size="small"
                                            label="Phone Number"
                                            disabled
                                            value={props.customernumber}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <CssTextField
                                            fullWidth
                                            size="small"
                                            label="Address"
                                            disabled
                                            value={props.customeraddressone}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <CssTextField
                                            fullWidth
                                            size="small"
                                            label=""
                                            disabled
                                            value={props.customeraddresstwo}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <CssTextField
                                            fullWidth
                                            size="small"
                                            label="Destination"
                                            disabled
                                            value={(props.custdest === '' || props.custdest === null || props.custdest === undefined) ? 'Not yet chosen' : props.custdest}
                                            
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <CssTextField
                                            fullWidth
                                            size="small"
                                            label="TAT"
                                            disabled
                                            value={(props.custtat === '' || props.custtat === null || props.custtat === undefined) ? 'Not yet chosen' : props.custtat}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <CssTextField
                                            fullWidth
                                            size="small"
                                            label="Design Software"
                                            disabled
                                            value={(props.dsoft === '' || props.dsoft === null || props.dsoft === undefined) ? 'Not yet chosen' : props.dsoft}
                                            
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12} sm={6}>
                                        <FormControl className={classes.forms}>
                                            <CssTextField
                                                size="small"
                                                label="State"
                                                multiline
                                                rows={1}
                                                rowsMax={2}
                                                disabled
                                                value={props.customerstate}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl variant="outlined" className={classes.forms}>
                                            <CssTextField
                                                size="small"
                                                label="Products"
                                                multiline
                                                rowsMax={2}
                                                disabled
                                                value={props.customerproduct}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl variant="outlined" className={classes.forms}>
                                            <CssTextField
                                                size="small"
                                                label="Scanners"
                                                multiline
                                                rowsMax={2}
                                                disabled
                                                value={props.customerscanner}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <CssTextField
                                            size="small"
                                            fullWidth
                                            label="Contact Name"
                                            disabled
                                            value={props.customercontactName}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <CssTextField
                                            fullWidth
                                            size="small"
                                            label="Contact Number"
                                            disabled
                                            value={props.customercontactNumber}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl variant="outlined" className={classes.forms}>
                                            <CssTextField
                                                size="small"
                                                label="Comments"
                                                multiline
                                                rowsMax={2}
                                                disabled
                                                value={props.customercomment}
                                            />
                                        </FormControl>
                                    </Grid> */}
                                </Grid>
                            </form>
                        </CardContentStyle>
                    </Card>
                </Container>
            </div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <Container component="main" maxWidth="sm">
                        <CssBaseline />
                        <div>
                            <Card className={classes.card}>
                                <CardHeader
                                    avatar={
                                        <Avatar aria-label="recipe" className={classes.avatar}>
                                            <AccountCircle />
                                        </Avatar>}
                                    title={<h2>Profile</h2>}
                                />
                                <CardContent>
                                    <form className={classes.form} noValidate>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12}>
                                                <CssTextField
                                                    size="small"
                                                    disabled
                                                    fullWidth
                                                    label="Lab Name"
                                                    onChange={event => props.updateCustomerName(event.target.value)}
                                                    defaultValue={props.custname}
                                                    value={props.customername}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    size="small"
                                                    fullWidth
                                                    autoFocus
                                                    label="Email Address"
                                                    onChange={event => props.updateEmail(event.target.value)}
                                                    defaultValue={props.emailid}
                                                    value={props.customeremail}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Phone Number"
                                                    onChange={event => props.updateNumber(event.target.value)}
                                                    defaultValue={props.phoneno}
                                                    value={props.customernumber}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Address Line 1"
                                                    onChange={event => props.updateAddressOne(event.target.value)}
                                                    defaultValue={props.address1}
                                                    value={props.customeraddressone}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Address Line 2"
                                                    onChange={event => props.updateAddressTwo(event.target.value)}
                                                    defaultValue={props.address2}
                                                    value={props.customeraddresstwo}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl size="small" className={classes.forms}>
                                                    <InputLabel ref={inputCon} htmlFor="outlined-age-native-simple">
                                                        Country
                                                    </InputLabel>
                                                    <Select
                                                        native
                                                        // labelWidth={con}
                                                        onChange={event => props.updateCountry(event.target.value as string)}
                                                        inputProps={{
                                                            name: 'Country',
                                                            id: 'outlined-age-native-simple',
                                                        }}
                                                        defaultValue={props.country}
                                                    >
                                                        <option disabled value="" />
                                                        {countries.map((country, index) => (
                                                            <option>{country.label}</option>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl className={classes.forms}>
                                                    <TextField
                                                        size="small"
                                                        label="State"
                                                        multiline
                                                        rows={1}
                                                        rowsMax={2}
                                                        defaultValue={props.state}
                                                        value={props.customerstate}
                                                        onChange={event => props.updateState(event.target.value)}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <FormControl variant="outlined" className={classes.forms}>
                                                    <TextField
                                                        size="small"
                                                        label="Products"
                                                        multiline
                                                        rowsMax={2}
                                                        defaultValue={props.products}
                                                        value={props.customerproduct}
                                                        onChange={event => props.updateProduct(event.target.value)}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <FormControl variant="outlined" className={classes.forms}>
                                                    <TextField
                                                        size="small"
                                                        label="Scanners"
                                                        multiline
                                                        rowsMax={2}
                                                        defaultValue={props.scanners}
                                                        value={props.customerscanner}
                                                        onChange={event => props.updateScanner(event.target.value)}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <FormControl size="small" className={classes.forms}>
                                                    <InputLabel ref={inputDs} htmlFor="demo-simple-select-outlined">
                                                        Design Software
                                                    </InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-outlined-label"
                                                        id="demo-simple-select-outlined"
                                                        defaultValue={props.dsoft}
                                                        onChange={(event) => props.updateDsoftware(event.target.value as string)}
                                                        value={props.custdsoft === null ? '' : props.custdsoft}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <em> Not yet chosen </em>
                                                        </MenuItem>
                                                        {
                                                            (Array.isArray(props.designSoftwares) && props.designSoftwares.length > 0) ?
                                                                props.designSoftwares.map((soft, index) => <MenuItem key={soft.recordid} value={soft.name}>{soft.name}</MenuItem>)
                                                                :
                                                                <MenuItem value="Exocad">Exocad</MenuItem>
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl size="small" className={classes.forms}>
                                                    <InputLabel ref={inputDes} htmlFor="demo-simple-select-outlined">
                                                        Destination
                                                    </InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-outlined-label"
                                                        id="demo-simple-select-outlined"
                                                        defaultValue={props.dsoft}
                                                        onChange={(event) => props.updateDestination(event.target.value as string)}
                                                        value={props.custdest === null ? '' : props.custdest}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <em> Not yet chosen </em>
                                                        </MenuItem>
                                                        {
                                                            (Array.isArray(props.orderDataManufacturer) && props.orderDataManufacturer.length > 0) ?
                                                                props.orderDataManufacturer.map((soft, index) => <MenuItem key={soft.dest} value={soft.dest}>{soft.dest}</MenuItem>)
                                                                :
                                                                <MenuItem value="In-House">In-House</MenuItem>
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl size="small" className={classes.forms}>
                                                    <InputLabel ref={inputTat} htmlFor="demo-simple-select-outlined">
                                                        TAT
                                                    </InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-outlined-label"
                                                        id="demo-simple-select-outlined"
                                                        defaultValue={props.dsoft}
                                                        onChange={(event) => props.updateTat(event.target.value as string)}
                                                        value={props.custtat === null ? '' : props.custtat}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <em> Not yet chosen </em>
                                                        </MenuItem>
                                                        {
                                                            (Array.isArray(props.orderDataTat) && props.orderDataTat.length > 0) ?
                                                                props.orderDataTat.map((soft, index) => <MenuItem key={soft.tattype} value={soft.tattype}>{soft.tattype}</MenuItem>)
                                                                :
                                                                <MenuItem value="Next Day 7 AM">Next Day 7 AM</MenuItem>
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    size="small"
                                                    fullWidth
                                                    label="Contact Name"
                                                    onChange={event => props.updateContactname(event.target.value)}
                                                    defaultValue={props.contactname}
                                                    value={props.customercontactName}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Contact Number"
                                                    onChange={event => props.updateContactnumber(event.target.value)}
                                                    defaultValue={props.contactno}
                                                    value={props.customercontactNumber}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControl variant="outlined" className={classes.forms}>
                                                    <TextField
                                                        size="small"
                                                        label="Comments"
                                                        multiline
                                                        rowsMax={2}
                                                        onChange={event => props.updateComment(event.target.value)}
                                                        defaultValue={props.comments}
                                                        value={props.customercomment}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item sm={6} className={classes.centerButton}>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    color="primary"
                                                    className={classes.submit}
                                                    onClick={handleSubmit}
                                                >
                                                    Update
                                                </Button>
                                            </Grid>
                                            <Grid item sm={6} className={classes.centerButton}>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    color="secondary"
                                                    className={classes.submit}
                                                    onClick={handleClose}
                                                >
                                                    Cancel
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </CardContent>
                            </Card>
                        </div>
                    </Container>
                </Fade>
            </Modal>
            {/* <div className={classes.paper}>
                <Container component="main" maxWidth="sm">
                    <CssBaseline />
                    <Card className={classes.cardone} variant="outlined">
                        <CardHeaderStyle
                            className={classes.cardHead}
                            title={
                                <h5>Design Preferences</h5>}
                            action={
                                <div>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleOpendp}
                                        startIcon={<EditIcon />}
                                    >
                                        Edit
                                    </Button>
                                </div>}
                        />
                        <CardContentStyle>
                            <form className={classes.form} noValidate>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <CssTextField
                                            size="small"
                                            fullWidth
                                            label="Occlusion"
                                            disabled
                                            value={props.occlusion}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <CssTextField
                                            size="small"
                                            fullWidth
                                            autoFocus
                                            label="Design Type"
                                            disabled
                                            value={props.designType}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <CssTextField
                                            fullWidth
                                            size="small"
                                            label="Pontic Design"
                                            disabled
                                            value={props.ponticDesign}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <CssTextField
                                            fullWidth
                                            size="small"
                                            label="Contact"
                                            disabled
                                            value={props.contact}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <CssTextField
                                            fullWidth
                                            size="small"
                                            label="Model Type"
                                            disabled
                                            value={props.modelType}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <CssTextField
                                            fullWidth
                                            size="small"
                                            label="Notes"
                                            disabled
                                            value={props.notes}
                                        />
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContentStyle>
                    </Card>
                </Container>
            </div> */}
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={opendp}
                onClose={handleClosedp}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={opendp}>
                    <Container component="main" maxWidth="sm">
                        <CssBaseline />
                        <div>
                            <Card className={classes.card}>
                                <CardHeader
                                    avatar={
                                        <Avatar aria-label="recipe" className={classes.avatar}>
                                            <AccountCircle />
                                        </Avatar>}
                                    title={<h2>Design Preferences</h2>}
                                />
                                <CardContent>
                                    <form className={classes.form} noValidate>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12}>
                                                <FormControl size="small" className={classes.forms}>
                                                    <InputLabel id="demo-simple-select-required-label">
                                                        Occlusion
                                                    </InputLabel>
                                                    <Select
                                                        // labelWidth={occ}
                                                        labelId="demo-simple-select-required-label"
                                                        id="demo-simple-select-required"
                                                        defaultValue={props.occlusion}
                                                        onChange={(event) => props.updateOcclusion(event.target.value as string)}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        {props.occulsionArr.map((occulsion, iOccul) => (
                                                            <MenuItem id={occulsion.rowno} key={iOccul} value={occulsion.listvalues}>{occulsion.listvalues}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <FormControl size="small" className={classes.forms}>
                                                    <InputLabel id="demo-simple-select-required-label">
                                                        Design Type
                                                    </InputLabel>
                                                    <Select
                                                        // labelWidth={dtype}
                                                        labelId="demo-simple-select-required-label"
                                                        id="demo-simple-select-required"
                                                        defaultValue={props.designType}
                                                        onChange={(event) => props.updateDesignType(event.target.value as string)}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        {props.designtypeArr.map((designtype, iDesign) => (
                                                            <MenuItem id={designtype.rowno} key={iDesign} value={designtype.listvalues}>{designtype.listvalues}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <FormControl size="small" className={classes.forms}>
                                                    <InputLabel id="demo-simple-select-required-label">
                                                        Pontic Design
                                                    </InputLabel>
                                                    <Select
                                                        // labelWidth={pdesign}
                                                        labelId="demo-simple-select-required-label"
                                                        id="demo-simple-select-required"
                                                        defaultValue={props.ponticDesign}
                                                        onChange={(event) => props.updatePonticDesign(event.target.value as string)}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        {props.ponticdesignArr.map((ponticdesign, iPontic) => (
                                                            <MenuItem id={ponticdesign.rowno} key={iPontic} value={ponticdesign.listvalues}>{ponticdesign.listvalues}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <FormControl size="small" className={classes.forms}>
                                                    <InputLabel id="demo-simple-select-required-label">
                                                        Contact
                                                    </InputLabel>
                                                    <Select
                                                        // labelWidth={cont}
                                                        labelId="demo-simple-select-required-label"
                                                        id="demo-simple-select-required"
                                                        defaultValue={props.contact}
                                                        onChange={(event) => props.updateContact(event.target.value as string)}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        {props.contactArr.map((contact, iContact) => (
                                                            <MenuItem id={contact.rowno} key={iContact} value={contact.listvalues}>{contact.listvalues}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <FormControl size="small" className={classes.forms}>
                                                    <InputLabel id="demo-simple-select-required-label">
                                                        Model Type
                                                    </InputLabel>
                                                    <Select
                                                        // labelWidth={mtype}
                                                        labelId="demo-simple-select-required-label"
                                                        id="demo-simple-select-required"
                                                        defaultValue={props.modelType}
                                                        onChange={(event) => props.updateModelType(event.target.value as string)}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        {props.modeltypeArr.map((modeltype, iModel) => (
                                                            <MenuItem id={modeltype.rowno} key={iModel} value={modeltype.listvalues}>{modeltype.listvalues}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    size="small"
                                                    fullWidth
                                                    label="Notes"
                                                    onChange={event => props.updateNotes(event.target.value)}
                                                    value={props.notes}
                                                />
                                            </Grid>
                                            <Grid item sm={6} className={classes.centerButton}>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    color="primary"
                                                    className={classes.submit}
                                                    onClick={handleSubmitdp}
                                                >
                                                    Update
                                                </Button>
                                            </Grid>
                                            <Grid item sm={6} className={classes.centerButton}>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    color="secondary"
                                                    className={classes.submit}
                                                    onClick={handleClosedp}
                                                >
                                                    Cancel
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </CardContent>
                            </Card>
                        </div>
                    </Container>
                </Fade>
            </Modal>
        </div >
    );
};

export default UserProfileView;



// WEBPACK FOOTER //
// ./src/components/layouts/UserProfileView.tsx